<template>

    <LayoutDefault>

       <b-row v-if="!passwordUpdated" class="fuid-login">

            <b-col cols="12 fuid-login_error">

                <errorFromServer
                    :id="id"
                />

            </b-col>

            <b-col cols="12"
                class="fuid-form-group"
                :class="{ 'form-group--error': $v.fields.password.$error }"
            >

                <label class="fuid-form__label">{{$t('login.genpassword')}}</label>
                <input class="fuid-form__input" v-model.trim="$v.fields.password.$model" :type="fieldType"/>
                <div class="error" v-if="!$v.fields.password.required">{{$t('forms.required')}}</div>
                <div class="error" v-if="!$v.fields.password.minLength">{{$t('forms.min',{ length: $v.fields.password.$params.minLength.min })}}</div>

            </b-col>

            <b-col cols="12"
                class="fuid-form-group"
                :class="{ 'form-group--error': $v.fields.passwordCheck.$error }"
            >

                <label class="fuid-form__label">{{$t('login.genpasswordre')}}</label>
                <input class="fuid-form__input" v-model.trim="$v.fields.passwordCheck.$model" :type="fieldType"/>
                <div class="error" v-if="!$v.fields.passwordCheck.sameAs">{{$t('forms.sameas')}}</div>

            </b-col>

            <b-col cols="12 d-flex justify-content-between align-items-center fuid-form__actions">

                <button class="fuid-button fuid-button-step align-items-center" @click.prevent="regenerate()">
                    
                    <b-spinner v-if="loading" variant="light" label="Loading..."></b-spinner>
                    <span v-else>{{$t('login.send')}}</span>
                    
                </button>

            </b-col>

        </b-row>

        <b-row v-else class="fuid-login-ok">

            <b-col cols="12" class="py-4">

                <h4 class="fuid-resu-tit text-center">{{ $t('login.passwordre') }}</h4>

                <p class="text-center pt-4">{{$t('login.redirect')}}</p>

                <p class="text-center pt-4">

                    <router-link class="fuid-button fuid-button-step align-items-center" :to="`/${$i18n.locale}`">
                    
                        {{$t('login.button')}}
                    
                    </router-link>

                </p>

            </b-col>

        </b-row>

    </LayoutDefault>

</template>

<script>

    import { mapActions } from 'vuex'
    import { mapGetters } from 'vuex'

    import { required, minLength, sameAs } from "vuelidate/lib/validators"
    import LayoutDefault from '@/components/layouts/LayoutDefault'
    import errorFromServer from '@/components/errorFromServer'
    import EyeIcon from '@/assets/svg/password-view.svg'

    export default {

        data() {

            return {

                fieldType: 'password',
                id: 3,
                logged: false,
                loading: false,
                validation_form: false,
                token: false,
                passwordUpdated: false,
                fields: {

                    password: '',
                    passwordCheck: ''

                }

            }

        },

        validations: {

            fields: {

                password: {
                    required,
                    minLength: minLength(6)
                },
                passwordCheck: {
                    required,
                    sameAsPassword: sameAs('password')
                }

            }

        },

        components: {

            LayoutDefault,
            errorFromServer

        },

        methods: {

            ...mapActions('Login', ['loginUser']),
            ...mapActions('Login', ['updatePassWordPlease']),

            /*
            * Send user data
            *
            */

            async regenerate () {

                this.$v.$touch()

                if (this.$v.$invalid) {
                    
                    this.validation_form = false

                } else {
                    
                    this.validation_form = true

                }

                if( this.validation_form ) {

                    this.loading = true

                    let logToken = await this.loginUser( { username: process.env.VUE_APP_API_USER, password: process.env.VUE_APP_API_PASSWORD, componentId: this.id } )
                    let newpassword = await this.updatePassWordPlease( { token: this.token, password: this.fields.password, componentId: this.id } )

                    this.loading = false

                    if( newpassword ) {
                        
                        this.resetForm()
                        localStorage.removeItem('logged')
                        this.passwordUpdated = true
                        this.toLogin()

                    }

                }

            },

            /*
            * Redirect the user to the login screen
            *
            */
           toLogin() {

               setTimeout(() => {
                   this.$router.push( { name:'ini' } )
                }, 6000)

           },

            /*
            * Empty login form
            *
            */
           resetForm() {

               this.fields.email = ''

           }

        },

        created() {

            this.token = this.$route.params.token

            if(!this.token) {

                this.router.push({ name: 'NotFound' })

            }

        }
        
    }

</script>